// Admin previews always draw the visitor page at desktop width (ScaledPreview's .preview-page)
export const PREVIEW_PAGE_WIDTH = 1200

export function isInPreview(el) {
  return !!el?.closest?.('.preview-page')
}

// Width the visitor page is drawn at: fixed inside a preview, else the window
export function pageWidth(el) {
  return isInPreview(el) ? PREVIEW_PAGE_WIDTH : document.documentElement.clientWidth
}
